<template>
  <div class="signDetail">
    <pageTitle class="getHeader" :title="title"></pageTitle>
    <div class="proBox">
      <!-- 选择企业 Strart -->
      <chooseEnt @getEntId="getEntId" :showEntId="entId" :showEntName="entName"/>
      <!-- 选择企业 End -->
      <div class="form-group">
        <label class="van-col--8">
          基地编号：<span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <input v-model="baseCode" placeholder="请填写基地编号"/>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          基地名称：<span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <input v-model="baseName" placeholder="请填写基地名称"/>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          基地类别：<span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <van-radio-group v-model="baseTypeId">
            <van-radio v-for="v in baseTypeList" :name="v.baseTypeId">{{
                v.baseTypeName
              }}
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          经度：<span class="imp">*</span>
        </label>
        <div class="van-col--10">
          <input v-model="lng" readonly placeholder="请打开GPS定位"/>
        </div>
        <div class="van-col--1">
        </div>
        <div class="van-col--4">
          <button class="toAddress" type="button" @click="getPoint">定位</button>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          纬度：<span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <input v-model="lat" readonly placeholder="请打开GPS定位"/>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          基地地址：
        </label>
        <div class="van-col--14">
          <input v-model="baseAddr" placeholder="请填写基地地址"/>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          基地规模：
        </label>
        <div class="van-col--14">
          <input v-model="scaleVal" type="number" placeholder="请填写基地规模"/>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          规模单位：
        </label>
        <div class="van-col--14">
          <input v-model="scaleValUnit" placeholder="请填写规模单位"/>
        </div>
      </div>
      <div class="drawMap">
        <p class="title">绘制地块：</p>
        <div class="mapContainer map-img" @click="toDrawMap" v-if="pointList.length === 0">
          <img src="drawMap.png">
        </div>
        <div class="mapContainer" v-else>
          <MapPointList class="map" :pointList="pointList" @toDelMap="toDelMap" @toEditMap="toEditMap" />
        </div>
      </div>
      <div class="photos">
        <p class="pic-title">基地照片(最多3张)：</p>
        <div class="photoList van-clearfix">
          <div
              class="imgBox"
              v-for="(item, index) in imgUpList"
              :key="'imgBox_'+index"
          >
            <div
                class="img"
                @click="showImagePreview('imgUpList', index)"
                :style="{'background-image': 'url(' + item.src + ')','background-repeat':'no-repeat','background-size':'cover', 'background-position':'center'}"
            ></div>
            <div class="deleted"
                 @click="deletePhoto('imgUpList', index)">×
            </div>
          </div>
          <div class="takePhoto" @click="takePhoto('imgUpList')">
            <p class="iconfont icon-camera"></p>
          </div>
        </div>
      </div>
      <div class="submit">
        <van-button round type="primary" @click="submit">点击提交</van-button>
      </div>
    </div>
    <!-- 经纬度 -->
    <van-popup v-model="pointShow" position="bottom">
      <MapPoint class="map" :mapHeight="mapHeight" @getCenter="getCenter"
                @closeMap="closeMap"></MapPoint>
    </van-popup>
  </div>
</template>


<script>
import { ImagePreview } from 'vant'
import MapPoint from '@/components/Gis/index'
import MapPointList from '@/components/MapPoint/MapPointList'
import chooseEnt from '@/components/common/chooseEnt/chooseEnt'
import {
  editEnterpriseProductionBase,
  getOneEnterpriseProductionBase,
  saveEnterpriseProductionBase,
} from '@/api/base'
import { getProductionBaseTypeList } from '@/api/dictionary'

export default {
  name: 'base-detail',
  components: {
    MapPoint,
    chooseEnt,
    MapPointList,
  },
  data () {
    return {
      title: '基地详情',
      entProdBaseId: '',
      imgUpList: [],
      pointShow: false,
      mapHeight: 0,
      entId: '',
      entName: '',
      baseCode: '',
      baseName: '',
      baseAddr: '',
      scaleVal: '',
      scaleValUnit: '',
      lat: '',
      lng: '',
      image1: '',
      image2: '',
      image3: '',
      headImg: '',
      baseTypeId: '',
      areaPoints: [],
      mapPic: '',
      baseTypeList: [],
      pointList: [],
    }
  },
  created () {
    // 获取详情
    this.entProdBaseId = this.$route.query.entProdBaseId || ''
    this.entProdBaseId && this.toGetOneEnterpriseProductionBase(this.entProdBaseId)
    // 获取基地类别
    this.toGetProductionBaseTypeList()

  },
  mounted () {
    // 地图高度
    this.mapHeight = innerHeight ? innerHeight : (document.documentElement &&
        document.documentElement.clientHeight)
        ? document.documentElement.clientHeight
        : document.body.offsetHeight

    window.setMapPoints = this.setMapPoints
    this.setMapPoints();
  },
  methods: {
    getEntId (data) { // 获取企业Id
      this.entId = data.entId || ''
      this.entName = data.entName || ''
      this.changeSwitch()
    },
    uploadPic (data) {
      this.mapPic = data
    },
    getPoint () {  // 打开地图
      this.pointShow = true
    },
    getCenter (data) { // 获取中心点
      if (data.address) this.baseAddr = data.address
      this.lat = data.lat
      this.lng = data.lng
      this.pointShow = false
    },
    closeMap () { // 关闭地图
      this.pointShow = false
    },
    setMapPoints (data) { // 安卓回写 坐标 和 图片
      if (!data || data.length === 0) return
      console.log(data)
      this.pointList = JSON.parse(data).map(s => {
        return { lat: s.latitude, lng: s.longitude }
      })
    },
    toDelMap(){
      console.log('删除')
      this.pointList = [];
    },
    toEditMap(){
      this.toDrawMap();
    },
    toDrawMap () {
      let u = navigator.userAgent
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        /* eslint-disable no-undef */
        window.webkit.messageHandlers.PlotDivision.postMessage(null)
      } else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
        /* eslint-disable no-undef */
        method.PlotDivision(JSON.stringify(this.pointList));
      }
    },
    showImagePreview (strName, index) {
      let images = this[strName] && this[strName][0] && this[strName].map(m => {
        return m.src
      }) || []
      ImagePreview({
        images,
        startPosition: typeof index === 'number' ? index : 0,
      })
    },
    deletePhoto (strName, index) {
      this[strName].splice(index, 1)
    },
    takePhoto (strName) {
      // 原生拍照回调
      let _this = this
      window.getPhotos = function (src) {
        if (src) {
          let list = src.split(';')
          list.forEach((v, k) => {
            if (k < 3) {
              _this[_this.strName].push({ src: v })
            }
          })
        } else {
          _this.$alertErr('上传失败！')
        }
      }
      this.strName = strName
      let u = navigator.userAgent
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        /* eslint-disable no-undef */
        window.webkit && window.webkit.messageHandlers.toaddPhoto.postMessage(null)
      } else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
        /* eslint-disable no-undef */
        method && method.choosePic()
      }
    },
    toGetOneEnterpriseProductionBase (entProdBaseId) { // 获取一个详情
      getOneEnterpriseProductionBase({
        entProdBaseId,
      }).then(res => {
        if (res.state === 'Y') {
          this.lng = res.data.lng || ''
          this.lat = res.data.lat || ''
          this.baseAddr = res.data.baseAddr || ''
          this.baseCode = res.data.baseCode || ''
          this.baseName = res.data.baseName || ''
          this.baseTypeId = res.data.baseTypeId || ''
          this.entId = res.data.entId || ''
          this.entName = res.data.entName || ''
          this.scaleVal = res.data.scaleVal || ''
          this.scaleValUnit = res.data.scaleValUnit || ''
          this.headImg = res.data.headImg || ''
          res.data.areaPoints && (this.areaPoints = JSON.parse(res.data.areaPoints))
          if (res.data.image1) this.imgUpList.push({ src: res.data.image1 })
          if (res.data.image2) this.imgUpList.push({ src: res.data.image2 })
          if (res.data.image3) this.imgUpList.push({ src: res.data.image3 })

        }
      }).catch(err => {
        console.log(err)
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
    toGetProductionBaseTypeList () { // 获取基地类别
      getProductionBaseTypeList({}).then(res => {
        if (res.state === 'Y') {
          this.baseTypeList = res.data
        }
      }).catch(err => {
        console.log(err)
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
    chooseWay (obj) {
      if (obj.entProdBaseId) {
        return editEnterpriseProductionBase(obj)
      } else {
        return saveEnterpriseProductionBase(obj)
      }
    },
    submit () {
      const baseCode = this.baseCode.trim()
      const baseName = this.baseName.trim()
      const baseAddr = this.baseAddr.trim()
      const scaleVal = this.scaleVal.trim()
      const scaleValUnit = this.scaleValUnit.trim()
      const headImg = this.headImg
      const baseTypeId = this.baseTypeId
      const areaPoints = this.areaPoints.length > 0 ? JSON.stringify(this.areaPoints) : ''
      const lng = this.lng || ''
      const lat = this.lat || ''
      const imageList = this.imgUpList || []
      const image1 = imageList[0] && imageList[0].src || ''
      const image2 = imageList[1] && imageList[1].src || ''
      const image3 = imageList[2] && imageList[2].src || ''

      if (!baseName || !baseCode || !String(baseTypeId)) {
        this.$toast('打 * 号为必填项！')
        return false
      }
      if (!lng || !lat) {
        this.$toast('请打开GPS并点击定位按钮！')
        return false
      }

      let obj = {
        baseCode,
        baseName,
        baseAddr,
        scaleVal,
        scaleValUnit,
        lat,
        lng,
        image1,
        image2,
        image3,
        headImg,
        baseTypeId,
        areaPoints,
      }
      this.entId && (obj.entId = this.entId)
      this.entProdBaseId && (obj.entProdBaseId = this.entProdBaseId)

      this.$dialog.confirm({
        title: '确认提交？',
        message: '',
      }).then(() => {
        let toa = this.$toast
        toa.loading({
          mask: true,
          message: '上传中...',
        })

        this.chooseWay(obj)
            .then((res) => {
              if (res.state === 'Y') { // 添加纸质合格证
                this.$toast.success('提交成功')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 2000)
              } else {
                this.$toast(res.msg)
                return false
              }
            })
            .catch((err) => {
              this.$toast('网络错误，稍后再试！')
              return false
            })

        // on confirm
      }).catch(() => {
        // on cancel
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.signDetail {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;


  & > .proBox {
    flex: 1;
    display: flex;
    flex-direction: column;

  }

  .submit {
    text-align: center;
  }

  .pageBox {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .page {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;

      .top {
        flex: 0 0 124px;

        .header {
          display: flex;
          background: #2ab774;

          .left {
            flex: 0 0 40px;
            height: 40px;
            position: relative;

            &:after {
              content: ' ';
              height: 8px;
              width: 8px;
              border-width: 2px 2px 0 0;
              border-color: #fff;
              border-style: solid;
              transform: matrix(-0.71, 0.71, 0.71, 0.71, 0, 0);
              position: absolute;
              top: 50%;
              left: 50%;
              margin-top: -4px;
              margin-left: 3.29px;
            }

            &:before {
              content: ' ';
              height: 8px;
              width: 8px;
              border-width: 2px 2px 0 0;
              border-color: #fff;
              border-style: solid;
              transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
              position: absolute;
              top: 50%;
              left: 50%;
              margin-top: -4px;
              margin-left: -8px;
            }
          }

          h1 {
            color: #fff;
            font-size: 17px;
            font-num: 500;
            line-height: 40px;
            text-align: center;
            box-sizing: border-box;
            flex: 1;
            text-indent: -40px;
          }
        }

        .totalNum {
          height: 30px;
          line-height: 30px;
          text-align: left;
          text-indent: 20px;
          background: #f5f5f5;
        }
      }

      .list {
        flex: 1;
        overflow-y: auto;

        .noDataText {
          height: 40px;
          line-height: 40px;
          text-align: center;
        }

        .van-list {
          height: 100%;
          width: 100%;

          .item {
            border-bottom: 1px dashed #ddd;
            height: 50px;
            line-height: 50px;
            text-align: left;
            padding-left: 20px;

            span {
              display: inline-block;
            }

            .span1 {
              margin-right: 10px;
              min-width: 40px;
              text-indent: 5px;
            }
          }
        }
      }
    }
  }
}

.form-group {
  height: auto;

  &.textarea {
    height: 20vw;

    textarea {
      height: 18vw !important;
      margin-top: 1vw !important;
      width: 100% !important;
      box-sizing: border-box;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 2vw;
      line-height: 4.5vw;
      resize: none;
    }
  }
}

.bags {
  p {
    display: block;
    min-height: 90px;
    border-bottom: 1px solid #ddd;
    padding: 10px 20px;
    box-sizing: border-box;

    .span1 {
      display: block;
      text-align: left;
      text-indent: 0;
      word-break: break-all;
      word-wrap: break-word;
      white-space: normal;
      line-height: 20px;
      padding-bottom 10px;
      box-sizing: border-box;
    }

    .span2 {
      display: block;
      text-align: right;
      text-indent: 0;
      height: 30px;
      line-height: 30px;
      color: #2ab774;
      font-weight: bold;
      border-top: 1px dashed #ddd;
    }

    .input {
      width: 100%;
      height: 30px;
      padding: 5px 10px;
      line-height: 20px;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid #ddd;
      vertical-align: middle;
      margin-bottom: 10px;
    }
  }
}

.drawMap {
  padding: 3vmin;
  background: #fff;

  .title {
    font-size: 4vmin;
    height: 8vmin;
  }

  .map-img {
    border-radius: 5px;
    font-size: 0;

    img {
      width: 100%;
    }
  }
  .mapContainer {
    overflow: hidden;
    border-radius: 5px;
  }
}

.van-radio-group .van-radio {
  width: 50%;
  float: left;
}
</style>
